import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangeSliderComponent } from './range-slider.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [RangeSliderComponent],
  exports: [RangeSliderComponent, ReactiveFormsModule],
  imports: [CommonModule, ReactiveFormsModule]
})
export class RangeSliderModule {}
